import React from "react";
import PropTypes from "prop-types";
const EMOJI_FLAG_SIZES = {
  small: 35,
  medium: 45,
  large: 70
};
const IMAGE_FLAG_SIZES = {
  small: {
    width: 30
  },
  medium: {
    width: 50
  },
  large: {
    width: 70,
    margin: "16px 0px"
  }
};
let supportsEmojis;
const check = () => {
  //eslint-disable-next-line
  if (supportsEmojis !== undefined) {
    return supportsEmojis;
  }
  if (navigator.appVersion.indexOf("Win") !== -1) {
    supportsEmojis = false;
  } else {
    supportsEmojis = true;
  }
  return supportsEmojis;
};
const Flag = ({
  countryCode,
  flag,
  size
}) => {
  let canRenderEmoji = false;
  try {
    canRenderEmoji = check();
  } catch (e) {
    //eslint-disable-next-line
    console.warn("Failed to check emoji supports ", e);
  }
  if (!countryCode) {
    return /*#__PURE__*/React.createElement("span", null);
  }
  if (canRenderEmoji && flag) {
    return /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: EMOJI_FLAG_SIZES[size]
      }
    }, flag);
  }
  try {
    const protocol = "https://";
    let domain = process.env.REACT_APP_PUBLIC_URL.replace("https://", "");
    domain = domain.split("/")[0];
    if (process.env.NODE_ENV === "development") {
      domain = process.env.REACT_APP_DEV_PUBLIC_URL;
    }
    const url = `${protocol}${domain}/content/en-GB/crowd-manager/flags/${countryCode.toLowerCase()}.png`;
    const imageStyles = IMAGE_FLAG_SIZES[size];
    return /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: `${countryCode} flag`,
      style: imageStyles
    });
  } catch {
    return /*#__PURE__*/React.createElement("span", null);
  }
};
export default Flag;
Flag.propTypes = {
  flag: PropTypes.string,
  size: PropTypes.string,
  countryCode: PropTypes.string
};
Flag.defaultProps = {
  size: "medium"
};